export default __webpack_public_path__ + "static/media/14.4d201d73.jpg";